import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteField from "../fields/DeleteField";


const DeleteFieldAlert = (props) => {
    const { onCompletion, id, onClose, element, messageId } = props;

    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
            container_id="delete-field"
        >

            <DeleteField messageId={messageId} onCompletion={onCompletion} element={element} id={id} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteFieldAlert;